import styled from 'styled-components';

export const TagsListContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 20px;
  padding: 20px;
`;
